/**
 * Convert a price form value ("", "12.50", null, 12.5) into what the API
 * should store. Blank means "not set", which must reach the API as null.
 * Storing 0 instead makes the form show a real $0 on the next load, and
 * downstream code cannot tell "free at the track" from "no track price".
 */
export const toNullablePrice = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? null : parsed;
};

/**
 * Order pricing tiers by app price, most expensive first. Tiers with no
 * usable price sort last. Ties keep their original relative order so the
 * form stays stable across reloads.
 */
export const sortTiersByPriceDesc = (tiers) =>
  [...(tiers || [])]
    .map((tier, index) => ({ tier, index }))
    .sort((a, b) => {
      const priceA = toNullablePrice(a.tier && a.tier.price);
      const priceB = toNullablePrice(b.tier && b.tier.price);
      if (priceA === priceB) return a.index - b.index;
      if (priceA === null) return 1;
      if (priceB === null) return -1;
      return priceB - priceA;
    })
    .map(({ tier }) => tier);
